export { VerificadorViajeEdit } from "./edit";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesEAD/verificar/index.ts